import gardenWalk from './community-garden-walk.json';
import type { TabSong } from './types';
/** Canonical community content. Bundled for an immediate, anonymous camera-only demo. */
export const COMMUNITY_TAB = gardenWalk as TabSong;
export const COMMUNITY_TAB_RECORD = {
  id: COMMUNITY_TAB.id,
  visibility: 'community' as const,
  configType: 'TAB' as const,
  name: COMMUNITY_TAB.title,
  artist: COMMUNITY_TAB.artist,
  key: 'G major',
  bpm: COMMUNITY_TAB.defaultBpm,
  license: 'CC0-1.0',
  parserType: 'authored',
  parserModelId: null,
  song: COMMUNITY_TAB,
};
